import { Injectable } from "@angular/core";
import { NotificationsService } from "angular2-notifications";
import { Observable } from "rxjs";
import { apiCallWrapper } from "../api/api.util";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";
import { HasId } from "../model/generics";
import { BlogApi } from "../api/blog.api";
import { IBlog, IBlogCreate } from "../model/blog.model";
import { LoadingService } from "./core/loading.service";

const className = "BlogService";

@Injectable()
export class BlogService {
	constructor(
		private notifications: NotificationsService,
		private blogApi: BlogApi,
		private loadingService: LoadingService
	) {}

	public list(query: IQueryFilter): Observable<QueryResult<IBlog>> {
		return apiCallWrapper(this.blogApi.list(query), {
			notificationsService: this.notifications,
			action: "Fetching blog",
		});
	}

	public get(id: string): Observable<IBlog> {
		return apiCallWrapper(this.blogApi.get(id), {
			notificationsService: this.notifications,
			action: "Fetching blog",
		});
	}

	public create(data: IBlogCreate): Observable<IBlogCreate & HasId<string>> {
		return apiCallWrapper(this.blogApi.create(data), {
			notificationsService: this.notifications,
			action: "Creating Blog",
		});
	}

	public update(
		data: IBlogCreate,
		id: string
	): Observable<IBlogCreate & HasId<string>> {
		return apiCallWrapper(this.blogApi.update(id, data), {
			notificationsService: this.notifications,
			action: "Updating Blog",
		});
	}

	public delete(id: string) {
		return apiCallWrapper(this.blogApi.delete(id), {
			notificationsService: this.notifications,
			action: "Deleting Blog",
		});
	}

	public updateStatus(id: string) {
		return apiCallWrapper(this.blogApi.updateStatus(id), {
			notificationsService: this.notifications,
			action: "Updating Blog Status",
		});
	}

	public webList(query: IQueryFilter): Observable<QueryResult<IBlog>> {
		return this.loadingService.blockWithLoadingOverlayRx(
			this.blogApi.webList(query)
		);
	}

	public webGet(
		id: string
	): Observable<{ data: IBlog; relatedArticles: IBlog[] }> {
		return this.loadingService.blockWithLoadingOverlayRx(
			this.blogApi.webGet(id)
		);
	}

	public checkSlug(
		slug: string,
		id: string | null
	): Observable<{ exists: boolean }> {
		return this.blogApi.checkSlug(slug, id);
	}
}
